import styled from 'styled-components';

export const Container = styled.div`
  table {
    min-width: 6.5rem;

    tbody tr:nth-child(2n + 1) {
      background: rgba(0, 0, 0, 0.02);
    }

    tbody tr.active {
      background: #fff;
      translate: 0;
      box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);

      :hover {
        background: #fff;
      }
    }
  }

  .MuiPaper-elevation1 {
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.01),
      0px 1px 1px 0px rgba(0, 0, 0, 0.01), 0px 1px 3px 0px rgba(0, 0, 0, 0.01);
  }

  .mobile {
    display: none;
    flex-direction: column;
  }

  @media (max-width: 425px) {
    .desktop {
      display: none;
    }

    .mobile {
      display: flex;
    }

    .MuiTablePagination-root {
      .MuiTablePagination-selectRoot {
        margin-right: 0;
      }

      .MuiTypography-colorInherit:last-of-type {
        display: none;
      }
    }
  }
`;

export const Created = styled.div`
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
